module.exports = __webpack_public_path__ + "static/media/tone_analyze_demo.0f38fa07.png";